module.exports = __webpack_public_path__ + "static/media/cross.a304dab3.svg";